<p-toast></p-toast>
<div class="provider-card">
    <div class="provider-title">
        <p-button
            icon="pi pi-arrow-left"
            (click)="backClicked()"
            [rounded]="true"
            size="small"
            [outlined]="true"
            class="mr-3"
            severity="secondary"
        />
        @if (providerDetail() !== null){
        <span class="text-600 font-bold text-2xl">{{
            providerDetail().name
        }}</span>
        }
    </div>
    @if (providerDetail() !== null){
    <div class="provider-details flex gap-6 flex-wrap mt-6">
        <div class="detail-item">
            <div class="detail-item-text flex flex-column">
                <span class="text-800 text-md">{{
                    providerDetail().status
                }}</span>
                <span class="text-xs text-400">Status</span>
            </div>
        </div>
        <div class="detail-item">
            <div class="detail-item-text flex flex-column">
                <span class="text-800 text-md">{{
                    providerDetail().contactEmail
                }}</span>
                <span class="text-xs text-400">Contact Email</span>
            </div>
        </div>
    </div>
    <div class="logo-display-image mt-4 flex flex-column">
        @if(blobUrl()===''){
        <i
            class="pi pi-image"
            style="font-size: 8rem; color: rgb(207, 207, 207)"
        ></i>
        } @else {
        <img [src]="blobUrl()" width="80" height="80" />
        }

        <span class="text-xs text-400">Provider logo</span>
    </div>
    <form
        class="upload-form"
        enctype="multipart/form-data"
        [formGroup]="documentForm"
    >
        <div class="flex gap-2 mt-4">
            <p-fileUpload
                name="myfile[]"
                mode="advanced"
                (onSelect)="onFileSelect($event)"
                (onClear)="onFileClear()"
                [customUpload]="true"
                (uploadHandler)="onUploadClicked($event)"
                accept=".jpg,.png,.svg,.jpeg"
            >
                <ng-template
                    pTemplate="content"
                    let-files
                    let-uploadedFiles="uploadedFiles"
                >
                    <div *ngIf="files?.length > 0">
                        <h6 class="mb-2 text-500">Ready to upload</h6>
                        <div class="flex flex-wrap p-0 gap-5">
                            <div
                                *ngFor="let file of files; let i = index"
                                class="m-0 px-2 flex surface-border align-items-center gap-6"
                            >
                                <span class="font-semibold">{{
                                    file.name
                                }}</span>
                                <p-button
                                    icon="pi pi-times"
                                    [outlined]="true"
                                    [rounded]="true"
                                    severity="danger"
                                />
                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="file"> </ng-template>
            </p-fileUpload>
        </div>
    </form>
    }
</div>
